import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

import styles from './backButton.module.css';

class BackButton extends Component {
  constructor(props) {
    super(props);
    this.state = { };
    this.goBack = this.goBack.bind(this);
  }

  goBack() {
    this.props.history.goBack();
  }

  render() {
    return (
      <Link className={this.props.className +' '+ styles.backButton} onClick={this.goBack} to="#">Back</Link>
    );
  }
}

export default withRouter(BackButton);



// WEBPACK FOOTER //
// ./src/components/BackButton/BackButton.jsx